import auth from 'api'
import { addToCondition, parseFilters, parsePage } from 'helpers/api'
import { useMutation, useQuery } from 'react-query'
//GET
export const getPackageActivities = async ({ queryKey }) => {
  const [, id, page, { filters = [] } = {}] = queryKey
  let condition = ''
  condition = parsePage(page, condition)
  condition = parseFilters(filters, condition)
  condition = addToCondition(condition, id, 'Module.package_id')

  const { data } = await auth({
    method: 'get',
    url: `auth/pkg/activities${condition}`,
  })
  return data
}
export const usePackageActivities = (
  id,
  page,
  { queryOptions = {}, queryFilters = {} } = {}
) => {
  return useQuery(
    ['packageActivities', id, page, queryFilters],
    getPackageActivities,
    {
      staleTime: 1000 * 60 * 60,
      ...queryOptions,
    }
  )
}
//GET
export const getActivities = async ({ queryKey }) => {
  const [, page, moduleId, { filters = [] } = {}] = queryKey
  let condition = ''
  condition = parsePage(page, condition)
  condition = parseFilters(filters, condition)
  condition = addToCondition(condition, moduleId, 'module_id')
  // condition = addToCondition(condition, moduleId, 'Module.id')

  const { data } = await auth({
    method: 'get',
    url: `auth/pkg/activities${condition}`,
  })
  return data
}
export const useActivities = (
  page,
  moduleId = null,
  { queryOptions = {}, queryFilters = {} } = {}
) => {
  const paginationIsDisabled = page == null

  return useQuery(['activities', page, moduleId, queryFilters], getActivities, {
    keepPreviousData: paginationIsDisabled ? false : true,
    staleTime: paginationIsDisabled ? 0 : 1000 * 60 * 10,
    ...queryOptions,
  })
}

export const getActivitiesForExport = async ({ queryKey }) => {
  const [, moduleId, { filters = [] } = {}] = queryKey
  const PER_PAGE = 1000
  let condition = `?per_page=0`
  condition = parseFilters(filters, condition)
  condition = addToCondition(condition, moduleId, 'module_id')

  const { data: activities } = await auth({
    method: 'get',
    url: `auth/pkg/activities${condition}`,
  })

  let totalActivities = activities

  if (activities.total_items >= PER_PAGE) {
    let totalPages = Math.ceil(totalActivities.total_items / PER_PAGE)
    for (
      let pageForPagination = 1;
      pageForPagination < totalPages;
      pageForPagination++
    ) {
      let conditionForPagination = `?page=${pageForPagination + 1}&per_page=0`
      conditionForPagination = parseFilters(filters, conditionForPagination)
      conditionForPagination = addToCondition(
        conditionForPagination,
        moduleId,
        'module_id'
      )
      const { data } = await auth({
        method: 'get',
        url: `auth/pkg/activities${conditionForPagination}`,
      })

      totalActivities.items = [...totalActivities.items, ...data.items]
    }
    totalActivities.per_page = totalActivities.total_items
    totalActivities.total_pages = 1
  }
  return totalActivities
  // return data
}
//POST
export const createActivity = async (payload) => {
  const { data } = await auth({
    method: 'post',
    url: `auth/pkg/activities`,
    data: {
      ...payload,
    },
  })
  return data
}
export const useCreateActivity = ({ queryOptions } = {}) => {
  return useMutation(createActivity, {
    ...queryOptions,
  })
}
//PUT
export const updateActivity = async ({ id, payload }) => {
  const { data } = await auth({
    method: 'put',
    url: `auth/pkg/activities/${id}`,
    data: {
      ...payload,
    },
  })
  return data
}
export const useUpdateActivity = ({ queryOptions } = {}) => {
  return useMutation(updateActivity, {
    ...queryOptions,
  })
}

//DELETE
export const deleteActivity = async (id) => {
  const { data } = await auth({
    method: 'delete',
    url: `auth/pkg/activities/${id}`,
  })
  return data
}
export const useDeleteActivity = ({ queryOptions } = {}) => {
  return useMutation(deleteActivity, {
    ...queryOptions,
  })
}

//POST
export const changeIdref = async (payload) => {
  const { data } = await auth({
    method: 'post',
    url: `auth/pkg/activities/changeidref`,
    data: {
      ...payload,
    },
  })
  return data
}
export const useChangeIdref = ({ queryOptions } = {}) => {
  return useMutation(changeIdref, {
    ...queryOptions,
  })
}
